module.exports = __webpack_public_path__ + "img/news1-3.ec668409.png";